import fetch from "lib/fetch";
import { OurServiceInterface, ServiceInterface } from "../../types/service";

interface ListResponse<T> {
    data: Array<T>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
}

type ServiceResponse = { data: ServiceInterface };
type OurServiceResponse = { data: OurServiceInterface };
type ValueResponse = { data: unknown };

export const getServicesRequest = (params?: HashMap<unknown>) =>
    fetch.get<ListResponse<ServiceInterface>>("service", { params });

export const getServiceRequest = (id: string) => fetch.get<ServiceResponse>(`service/${id}`);

export const getOurServicesRequest = (params?: HashMap<unknown>) =>
    fetch.get<ListResponse<OurServiceInterface>>("our_service", { params });

export const getOurServiceRequest = (id: string) => fetch.get<OurServiceResponse>(`our_service/${id}`);

export const createServiceRequest = (data: unknown) => fetch.post<ServiceResponse>("service", data);

export const updateServiceRequest = (id: string, data: unknown) =>
    fetch.put<ServiceResponse>(`service/${id}`, data);

export const deleteServiceRequest = (id: string) => fetch.delete<ServiceResponse>(`service/${id}`);

export const getServiceAvgPriceRequest = (params?: HashMap<unknown>) =>
    fetch.get<ValueResponse>("service/all/avg_price", { params });

export const getServiceMinSalaryRequest = () => fetch.get<ValueResponse>("service/all/min_salary");
